import { CompSelectionProperty, QualityTierBreakdownData } from '../../types.ts';

export const getQualityTierBreakdownData = (properties: CompSelectionProperty[]) : QualityTierBreakdownData => {
  const propertiesByQualityTier: Record<number, { properties: CompSelectionProperty[], priceBand?: string, medianGla?: string, countOfSales?: number }> = properties.reduce((acc, p) => {
    if (!p.qualityTier) return acc;
    if (!acc[p.qualityTier]) {
      acc[p.qualityTier] = { properties: [] };
    }
    acc[p.qualityTier]!.properties.push(p);
    return acc;
  }, {} as Record<number, { properties: CompSelectionProperty[] }>);

  // Sort each tiers by sold price
  Object.entries(propertiesByQualityTier).forEach(([tier, props]) => {
    propertiesByQualityTier[Number(tier)]!.properties = props.properties.sort((a, b) => a.salePrice!.toDollarLike() - b.salePrice!.toDollarLike());

    if (props.properties.length === 1) {
      propertiesByQualityTier[Number(tier)]!.priceBand = props.properties[0]!.salePrice!.toString(true);
    } else {
      propertiesByQualityTier[Number(tier)]!.priceBand = `${props.properties[0]!.salePrice!.toString(true)} - ${props.properties[props.properties.length - 1]!.salePrice!.toString(true)}`;
    }

    const sortedPropertyGlas = props.properties.filter((p) => !!p.gla).map((p) => p.gla!).sort((a, b) => a.toSqFt().unitAmount - b.toSqFt().unitAmount);
    propertiesByQualityTier[Number(tier)]!.medianGla = sortedPropertyGlas[Math.floor(sortedPropertyGlas.length / 2)]!.toString();

    propertiesByQualityTier[Number(tier)]!.countOfSales = props.properties.length;
  });

  return propertiesByQualityTier;
}
